import React, { createContext, useContext, ReactNode } from "react";
import AreaProDialog from "./AreaProDialog";
import { useAreaPro as useAreaProHook } from "./useAreaPro";

interface AreaProContextType {
  openAreaPro: ReturnType<typeof useAreaProHook>["openAreaPro"];
}

const AreaProContext = createContext<AreaProContextType | undefined>(undefined);

export const useAreaPro = () => {
  const context = useContext(AreaProContext);
  if (!context) {
    throw new Error("useAreaPro must be used within an AreaProProvider");
  }
  return context;
};

const AreaProProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { openAreaPro, closeAreaPro, isOpen, insightsUrl, isLoading } =
    useAreaProHook();

  return (
    <AreaProContext.Provider value={{ openAreaPro }}>
      {children}
      <AreaProDialog
        isOpen={isOpen}
        onClose={closeAreaPro}
        insightsUrl={insightsUrl}
        isLoading={isLoading}
      />
    </AreaProContext.Provider>
  );
};

export default AreaProProvider;
